export function MemberListItemSkeleton() {
  return (
    <ul className="space-y-2">
      {Array.from({ length: 3 }).map((_, index) => (
        <li
          key={`member-skeleton-${index}`}
          className="flex items-center justify-between rounded-xl border border-base-300 bg-base-100 p-4"
        >
          <div className="space-y-2">
            <div className="skeleton h-4 w-32 rounded" />
            <div className="skeleton h-3 w-20 rounded" />
          </div>
          <div className="skeleton h-7 w-16 rounded" />
        </li>
      ))}
    </ul>
  );
}
